import React, { useState, useEffect } from 'react'

const ImageWithApiKey: React.FC<{
  imageUrl?: string
  apiKey: string
  className?: string
  height?: string
  minHeight?: string
  onError?: (event: React.SyntheticEvent<HTMLImageElement, Event>) => void
}> = ({ imageUrl, apiKey, className }) => {
  return (
    <img
      src={imageUrl ?? '/images/default-placeholder.jpg'}
      alt='Gallery'
      className={`w-full h-full object-cover ${className}`}
      onContextMenu={e => e.preventDefault()}
      onDragStart={e => e.preventDefault()}
    />
  )
}

export default ImageWithApiKey
